import React from "react";
import PropTypes from "prop-types";
import SortableTree from "react-sortable-tree";
import CategoryRepository from "../../repository/CategoryRepository";
import FormToastComponent from "../basics/FormToastComponent";
import LoaderComponent from "../basics/layout/LoaderComponent";

class CategoryOverviewTreeComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            treeData: [],
            index: this.props.index
        }
    }

    componentDidMount() {
        this.setState({ treeData: this.format(this.props.data) })
    }

    update = () => CategoryRepository.updateTree(this.state.treeData)
        .then(response => {
            FormToastComponent.successTrans("Categories", "CMS.Categories.overview.tree.updated")
            this.props.parent.updateData()
        })
        .catch(error => {
            console.error(error.message);
            FormToastComponent.successTrans("Categories", "CMS.Categories.overview.tree.failed")
        });

    format(array, parent = null) {
        let formattedArray = [];
        let parentComponent = this;

        array.forEach(function (category) {
            if (category['category']['parent'] === parent) {
                let childArray = parentComponent.format(array, category['id']);
                category = {
                    title: category['title'] + '    ( id {' + category['id'] + '})',
                    id: category['id'],
                    children: childArray,
                    expanded: true
                }

                formattedArray.push(category)
            }
        })

        return formattedArray;
    }

    render() {
        if (this.state.treeData.length === 0) return <LoaderComponent />
        
        return (
            <div style={{ height: 500 }}>
                <SortableTree
                    treeData={this.state.treeData}
                    onChange={treeData => this.setState({ treeData })}
                    onMoveNode={(data) => this.update(data)}
                    maxDepth={this.props.maxDepth ? this.props.maxDepth : 3}
                />
            </div>
        );
    }

}

CategoryOverviewTreeComponent.propTypes = {
    data: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
    parent: PropTypes.object.isRequired
};
export default CategoryOverviewTreeComponent
